import { defineComponent as _defineComponent } from 'vue'
import EditIcon from '@/components/molecules/EditIcon.vue';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';

import IconAddressData from '@/components/svg/invoices/addressdata.svg?inline';
import IconAttachments from '@/components/svg/invoices/attachments.svg?inline';
import IconBasisData from '@/components/svg/invoices/basisdata.svg?inline';
import IconPaymentData from '@/components/svg/invoices/paymentdata.svg?inline';
import IconPositions from '@/components/svg/invoices/positions.svg?inline';
import IconTexts from '@/components/svg/invoices/texts.svg?inline';
import { PropType, ref, watch } from 'vue';
import ConfirmButtons from '@/components/molecules/ConfirmButtons.vue';
import BCXEditedIndicator from '@/components/molecules/forms/BCXEditedIndicator.vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import { templateRef } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceSection',
  props: {
  title: {
    type: String,
    default: ''
  },
  icon: {
    type: String as PropType<keyof typeof icons>,
    required: true
  },
  canEdit: Boolean,
  saveCallback: {
    type: Function,
    default: null
  },
  autoSaveTrigger: {
    type: Number,
    default: 0
  },
  helpText: {
    type: String,
    default: ''
  }
},
  emits: ['save', 'cancel'],
  setup(__props, { emit }) {

const props = __props;

const icons = {
  addressdata: IconAddressData,
  attachments: IconAttachments,
  basisdata: IconBasisData,
  paymentdata: IconPaymentData,
  positions: IconPositions,
  texts: IconTexts,
};





const isHelptextOpen = ref(false);
const isSaving = ref(false);
const isEditing = ref(false);
const { isMobileWidth } = useResponsiveness();
const rootElm = templateRef('ref');

const onSave = async () => {
  isSaving.value = true;
  if (props.saveCallback) {
    await props.saveCallback();
    isEditing.value = false;
    isSaving.value = false;
  }
};

const onCancel = () => {
  emit('cancel');
  isEditing.value = false;
  isSaving.value = false;
};

watch(isEditing, (is) => {
  if (!is) {
    rootElm.value.scrollIntoView({ behavior: 'smooth' });
  }
});


return { __sfc: true,icons, props, emit, isHelptextOpen, isSaving, isEditing, isMobileWidth, rootElm, onSave, onCancel, EditIcon, BCXHelpTextTriggerIcon, ref, ConfirmButtons, BCXEditedIndicator, BCXInfoCollapsible }
}

})